// Tailwind class string shared by every clinical/DM/VA form input.
export const baseFieldClasses =
    'w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 bg-white focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 transition-colors placeholder:text-gray-400';
